import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';

@Component({
  selector: 'tt-collection',
  templateUrl: './collection.component.html',
  styleUrls: ['./collection.component.css']
})
export class CollectionComponent implements OnInit {
    public collectionKeyno;

    public edit?: Edit;

    public saving = false;

    constructor(private stateService: StateService, private modal: ModalService, private datatask: DataTaskService) {
        this.collectionKeyno = this.stateService.getStateParams()['collection_keyno'];
    }

    private async loadEdit() {
        if (!!this.collectionKeyno) {
            this.edit = (await this.datatask.Post(1220, { collection_keyno: this.collectionKeyno }))[0];
        }
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1221, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadEdit();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    collection_keyno: string;
    collection_name: string;
    isactive: string;
    valid_from_date: string;
    valid_to_date: string;
    price_valid_from_date: string;
    publish_web: string;
    web_date: string;
    catalogue_name: string;
    preorder_from_date: string;
    preorder_to_date: string;
    collection_short_description: string;
    seasonyear_id: string;
    active_preorder: string;
}
